const system_limit = {
    limit_exceeded: 'คุณใช้ระบบจนถึงขีดจำกัดแล้ว โปรดติดต่อฝ่ายสนับสนุนเพื่อขอความช่วยเหลือ',
};
export default Object.freeze(system_limit);
